<template>
  <div class="department-authority">
    <second-menu-link-content>
      <template v-slot:header>
        <span class="title" @click="goDepartmentManage">部门管理/</span>权限设置
      </template>
      <template v-slot:content>
        <div class="department-authority-main">
          <div class="tit" ref="steps">
            <span>当前部门：{{ name }}</span>
          </div>
          <div class="authority-lists">
            <div class="list" v-for="(value,index) in lists" :key="index">
              <div class="list-title">
                <el-checkbox
                  :indeterminate="value.isIndeterminate"
                  v-model="value.checkAll"
                  @change="handleCheckAllChange(index,value.checkAll)"
                >{{value.title}}</el-checkbox>
              </div>
              <div class="list-child">
                <!-- <el-checkbox-group
                  v-model="value.authority"
                  @change="handleCheckedCitiesChange(index,value.authority)"
                >
                  <el-checkbox
                    v-for="(child, index) in value.children"
                    :label="child.id"
                    :key="index"
                  >{{child.name}}</el-checkbox>
                </el-checkbox-group> -->
                  <el-checkbox-group
                    v-model="value.authority"
                    @change="handleCheckedCitiesChange(index,value.authority)"
                  >
                    <div
                      style="display:inline-block;"
                      v-for="(child, idx) in value.children"
                      :key="idx"
                    >
                      <el-checkbox
                        :class="child.keyword == 'ROLE_TOP_WRITE'?'active':''"
                        :label="child.id"
                      >
                        {{child.name}}
                      </el-checkbox>
                      <el-dropdown 
                        v-if="child.keyword == 'ROLE_TOP_WRITE'" 
                        trigger="click" 
                        @command="handleCommand">
                        <span class="el-dropdown-link">
                          {{COLUMN_TYPE[columnType]}}<i class="el-icon-caret-bottom"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" class="client-dropdown">
                          <el-dropdown-item 
                          :command="beforeHandleCommand('one', firstColumnId, index)">首个栏目</el-dropdown-item>
                          <el-dropdown-item
                          :command="beforeHandleCommand('all', allColumnId, index)"
                          >所有栏目</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </el-checkbox-group>
              </div>
            </div>
          </div>
          <div class="bottom">
            <div class="operations" ref="operations">
              <el-button class="btn-white" @click="goDepartmentManage">取消</el-button>
              <el-button class="btn-blue" @click="save">保存</el-button>
            </div>
          </div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from 'components/layout/SecondMenuLinkContent';
import DBSiteSet from 'models/db/site-set.js';
const dbSiteSet = new DBSiteSet();
export default {
  data() {
    return {
      name: '', // 当前部门名字
      id: '', // 当前部门id
      authorityIds: [], // 当前部门权限
      lists: [
        // {
        //   title: '商品',
        //   checkAll: false,
        //   authority: [],
        //   children: [],
        //   isIndeterminate: false
        // }
      ],
      // 选择的栏目
      columnType: '',
      // 首个栏目id
      firstColumnId: '',
      // 所有栏目id
      allColumnId: '',
      COLUMN_TYPE: {
        // firstColumnId: '首个栏目',
        // allColumnId: '所有栏目',
      },
    };
  },
  components: {
    SecondMenuLinkContent
  },
  mounted() {
    const paddingWidth = 48;
    this.$refs.operations.style.width =
      this.$refs.steps.clientWidth + paddingWidth - 16 + 'px';
    window.onresize = () => {
      this.$refs.operations.style.width =
        this.$refs.steps.clientWidth + paddingWidth - 16 + 'px';
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /* 
      返回新的command对象
      value即需要传递的额外参数
     */
    beforeHandleCommand(command, value, index){
      return {
        'value': value,
        'index': index,
        'command':command
      }
    },
    handleCommand(command) {
      let authority = this.lists[command.index].authority
      switch (command.command) {
        case "one":
          let arr = []
          authority.map(i => {
            if (i != this.allColumnId) {
              arr.push(i)
            }
          })
          this.lists[command.index].authority = arr
          this.columnType = command.value
          break;
        case "all":
          let arrCopy = []
          authority.map(i => {
            if (i != this.firstColumnId) {
              arrCopy.push(i)
            }
          })
          this.lists[command.index].authority = arrCopy
          this.columnType = command.value
          break;
      }
    },
    // 根据当前页id获取权限数据
    getAuthority() {
      let id = this.id;
      dbSiteSet.getDBDepartmentById(id).then(res => {
        if (res.success) {
          let arr = res.result.authorityIds;
          this.name = res.result.name;
          this.lists.map((value, index, array) => {
            arr.map((v, i, a) => {
              if (value.id === v.id) {
                this.$set(this.lists[index], 'authority', v.authorityIds);
                if (v.id == 4) {
                  let columnList = [this.allColumnId, this.firstColumnId]
                  v.authorityIds.map(j => {
                    if (columnList.indexOf(j) !== -1) {
                      this.columnType = j
                    }
                  })
                }
              }
            });
            if (
              this.lists[index].authority.length ===
              this.lists[index].children.length
            ) {
              this.lists[index].checkAll = true;
            } else if (
              this.lists[index].children.length >
                this.lists[index].authority.length &&
              this.lists[index].authority.length > 0
            ) {
              this.lists[index].isIndeterminate = true;
            }
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取权限列表数据
    getList() {
      dbSiteSet.getDBAuthority().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map((value, index, array) => {
            let obj = {};
            obj.title = value.name;
            obj.id = value.id;
            obj.checkAll = false;
            obj.isIndeterminate = false;
            obj.authority = [];
            obj.children = [];
            value.authorities.map((value, index, array) => {
              let child = {};
              child.name = value.name;
              child.id = value.id;
              child.keyword = value.keyword;
              if (value.keyword === 'ROLE_TOP_WRITE_FIRST') {
                this.firstColumnId = value.id
                this.columnType = value.id
                this.COLUMN_TYPE[this.firstColumnId] = '首个栏目'
              }
              if (value.keyword === 'ROLE_TOP_WRITE_ALL') {
                this.allColumnId = value.id
                this.COLUMN_TYPE[this.allColumnId] = '所有栏目'
              }
              if (value.keyword !== 'ROLE_TOP_WRITE_FIRST' && value.keyword !== 'ROLE_TOP_WRITE_ALL') obj.children.push(child);
            });
            arr.push(obj);
          });
          this.lists = arr;
          this.id = this.$route.query.id;
          this.getAuthority();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 返回上一页面
    goDepartmentManage() {
      this.$router.push('department-manage');
    },
    // 全选函数
    handleCheckAllChange(index, val) {
      let arr = [];
      this.lists[index].children.map((value, index, array) => {
        arr.push(value.id);
      });
      this.lists[index].authority = val ? arr : [];
      this.lists[index].isIndeterminate = false;
    },
    // 单个选择触发函数
    handleCheckedCitiesChange(index, value) {
      let checkedCount = value.length;
      this.lists[index].checkAll =
        checkedCount === this.lists[index].children.length;
      this.lists[index].isIndeterminate =
        checkedCount > 0 && checkedCount < this.lists[index].children.length;
    },
    // 保存修改
    save() {
      // 合并所有的数组
      let arr = [];
      this.lists.map((value, index, Array) => {
        let obj = {};
        obj.id = value.id;
        obj.authorityIds = value.authority;
        if (value.id == 4) {
          obj.authorityIds.push(this.columnType)
          obj.authorityIds = [...new Set(obj.authorityIds)]
        }
        arr.push(obj);
      });
      let id = Number(this.id);
      let name = this.name;
      let authorityIds = arr;
      dbSiteSet.postDBUpdateDepartment(id, name, authorityIds).then(res => {
        if (res.success) {
          this.$message.success('修改成功');
          this.$router.push('/admin/setting/department/department-manage');
        } else {
          this.$message.error(res.message);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.department-authority {
  width: 100%;
  height: 100%;
  .title {
    color: rgba(61, 116, 242, 0.75);
    cursor: pointer;
    &:hover {
      color: rgba(61, 116, 242, 1);
    }
  }
  .department-authority-main {
    .tit {
      box-sizing: border-box;
      height: 32px;
      background: rgba(245, 247, 250, 1);
      border-radius: 8px 8px 0px 0px;
      border: 1px solid rgba(234, 238, 245, 1);
      font-weight: 400;
      color: rgba(48, 49, 50, 1);
      padding: 0 6px;
      display: flex;
      align-items: center;
      font-size: 16px large;
      margin-bottom: 16px;
    }
    .authority-lists {
      .list {
        margin-bottom: 16px;
        font-size: 14px;
        letter-spacing: 1px;
        .list-title {
          height: 40px;
          box-sizing: border-box;
          background: rgba(234, 238, 245, 0.2);
          border-radius: 8px 8px 0px 0px;
          border: 1px solid rgba(234, 238, 245, 1);
          padding: 0px 30px 0 16px;
          display: flex;
          align-items: center;
        }
        .list-child {
          box-sizing: border-box;
          border: 1px solid #f2f6fc;
          border-top: 0;
          padding: 0px 30px 0 36px;
          display: flex;
          align-items: center;
          .el-checkbox {
            line-height: 40px;
            margin-right: 64px;
          }
          .active {
            margin-right: 10px;
          }
          .el-dropdown-link {
            margin-right: 64px;
            cursor: pointer;
          }
        }
      }
    }
    .bottom {
      height: 40px;
      .operations {
        z-index: 10000;
        height: 60px;
        position: fixed;
        left: 256px;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 6px 0px rgba(219, 223, 230, 1);
        .el-button {
          width: 96px;
          letter-spacing: 4px;
        }
        .el-button + .el-button {
          margin-left: 24px;
        }
      }
    }
  }
}
</style>
